import axios from 'axios';

let prefix_1 = "/laboratory"
let prefix_2 = "/laboratory-item"

const LaboratoryApi = {
	//Laboratory Service
	getLaboratoryServiceList(payload){
		return axios.get( prefix_1 + "/list", {params: payload})
	},
	archiveLaboratoryService(payload){
		return axios.delete( prefix_1 + "/delete", {params: payload})
	},
	createLaboratoryService(payload){
		return axios.post( prefix_1 + "/create", payload)
	},
	updateLaboratoryService(payload){
		return axios.post( prefix_1 + "/update", payload)
	},
	setLaboratoryServiceImage(payload, onUploadProgress = {} ){
		return axios.post(prefix_1 + "/upload", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},
	clearLaboratoryServiceImage(payload){
		return axios.delete( prefix_1 + "/delete-image", {params: payload})
	},

	//Laboratory Service Item
	getLaboratoryServiceItemList(payload){
		return axios.get( prefix_2 + "/list", {params: payload})
	},
	archiveLaboratoryServiceItem(payload){
		return axios.delete( prefix_2 + "/delete", {params: payload})
	},
	createLaboratoryServiceItem(payload){
		return axios.post( prefix_2 + "/create", payload)
	},
	updateLaboratoryServiceItem(payload){
		return axios.post( prefix_2 + "/update", payload)
	},
	setLaboratoryServiceItemImage(payload, onUploadProgress = {} ){
		return axios.post(prefix_2 + "/upload", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},
	clearLaboratoryServiceItemImage(payload){
		return axios.delete( prefix_2 + "/delete-image", {params: payload})
	},
}

export default LaboratoryApi;